// import AutoNumeric from 'autonumeric';

$(function () {
  const estLaborCost = {
    init() {
      estLaborCost.create();
    },
    create() {
      const form = $("[data-est-labor-cost]");
      if (form.length === 0) return;

      function debounce(func, delay) {
        let timeout;

        return function executedFunc(...args) {
          if (timeout) {
            clearTimeout(timeout);
          }

          timeout = setTimeout(() => {
            func(...args);
            timeout = null;
          }, delay);
        };
      }

      form.validate({
        rules: {
          "contract_term": {
            required: true,
          },
          "gross_salary": {
            required: true,
          },
          "total_allowance": {
            required: true,
          },
          "performance_bonus": {
            required: true,
          },
          "medical_check_up": {
            required: true,
          },
          "hi_and_pa_employee": {
            required: true,
          },
          "hi_and_pa_dependent": {
            required: true,
          },
        },
        messages: {
          "contract_term": {
            required: form.data('msg-required'),
          },
          "gross_salary": {
            required: form.data('msg-required'),
          },
          "total_allowance": {
            required: form.data('msg-required'),
          },
          "performance_bonus": {
            required: form.data('msg-required'),
          },
          "medical_check_up": {
            required: form.data('msg-required'),
          },
          "hi_and_pa_employee": {
            required: form.data('msg-required'),
          },
          "hi_and_pa_dependent": {
            required: form.data('msg-required'),
          },
        }
      });

      function objectifyForm(formArray) {
        var returnArray = {};
        for (var i = 0; i < formArray.length; i++) {
          returnArray[formArray[i]["name"]] = formArray[i]["value"];
        }
        return returnArray;
      }

      const formatNumber = (value) => {
        return parseFloat(value || 0);
      };

      const MAX_GROSS_SI = 36000000;

      const getSi1P = (grossSalary) => {
        // 1' = Nếu mức lương gross thấp hơn 36.000.000 thì lấy mức lương hiện tại (tức mức gross salary) x 17.5%, nếu cao hơn thì lấy mức trần là 36.000.000 x 17.5%
        const currentGrossSalary = formatNumber(grossSalary);
        if (currentGrossSalary < MAX_GROSS_SI) {
          return (currentGrossSalary * 17.5) / 100;
        }

        return (MAX_GROSS_SI * 17.5) / 100;
      };

      const getMi1P = (grossSalary) => {
        // 1' = Nếu mức lương gross thấp hơn 36.000.000 thì lấy mức lương hiện tại x 3%, nếu cao hơn thì lấy mức trần là 36.000.000 x 3%
        const currentGrossSalary = formatNumber(grossSalary);
        if (currentGrossSalary < 88400000) {
          return (currentGrossSalary * 3) / 100;
        }

        return (MAX_GROSS_SI * 3) / 100;
      };

      const getUi1P = (grossSalary) => {
        // 1'' = Nếu mức lương gross thấp hơn 93.600.000 thì lấy mức lương hiện tại x 1%, nếu cao hơn thì lấy mức trần là 93.600.000 x 1%
        const currentGrossSalary = formatNumber(grossSalary);
        if (currentGrossSalary < 93600000) {
          return (currentGrossSalary * 1) / 100;
        }

        return (93600000 * 1) / 100;
      };

      const getTu1P = (grossSalary) => {
        // 1'' = Nếu mức lương gross thấp hơn 36.000.000 thì lấy mức lương hiện tại x 1%, nếu cao hơn thì lấy mức trần là 36.000.000 x 1%
        const currentGrossSalary = formatNumber(grossSalary);
        if (currentGrossSalary < MAX_GROSS_SI) {
          return (currentGrossSalary * 2) / 100;
        }

        return (MAX_GROSS_SI * 2) / 100;
      };

      const numberWithCommas = (x) => {
        return x
          .toString()
          .replace(
            /\B(?=(\d{3})+(?!\d))/g,
            `${$("html")[0].lang === "en-US" ? "," : "."}`
          );
      };

      const eventHandler = (event) => {
        if (!form.hasClass('showed') && event.target.value) {
          form.addClass('showed');

          form.find('.form-group').stop().show();
        }
      };

      const dHandler = debounce(eventHandler, 350);

      form.find('input[name=contract_term]').on('input', dHandler);

      form.on("submit", function (e) {
        e.preventDefault();

        if (form.valid()) {
          const {
            contract_term,
          } = objectifyForm(form.serializeArray()) || {};

          const gross_salary = AutoNumeric.getNumber('input[name="gross_salary"]');
          const total_allowance = AutoNumeric.getNumber('input[name="total_allowance"]');
          const performance_bonus = AutoNumeric.getNumber('input[name="performance_bonus"]');
          const medical_check_up = AutoNumeric.getNumber('input[name="medical_check_up"]');
          const hi_and_pa_employee = AutoNumeric.getNumber('input[name="hi_and_pa_employee"]');
          const hi_and_pa_dependent = AutoNumeric.getNumber('input[name="hi_and_pa_dependent"]');
  
          // TOTAL INCOME = (3) = (1) + (2)
          const total_income =
            (formatNumber(gross_salary) * formatNumber(contract_term)) + (formatNumber(total_allowance) * formatNumber(contract_term));
  
          // (4) = (1)' x 17.5% (1)' là mức lương tối đa đóng bảo hiểm < = 36.000.000
          const si = getSi1P(gross_salary);
  
          // (5) = (1)' x 3%
          const mi = getMi1P(gross_salary);
  
          // (6) = (1)'' x 1% (1)'' là mức lương tối đa đóng bảo hiểm thất nghiệp <= 88.400.000
          const ui = getUi1P(gross_salary);
  
          // (7) = (1)' x 2%
          const tu = getTu1P(gross_salary);
  
          // (8) = ((1) / 12) x contract term*
          const yearBonus = formatNumber(gross_salary);
  
          // TOTAL LABOR COST (13) = (3) + (4) + (5) + (6) + (7) + (8) + (9) + (10) + (11) + (12)
          const total_labor_cost =
            total_income +
            (si * formatNumber(contract_term)) +
            (mi * formatNumber(contract_term)) +
            (ui * formatNumber(contract_term)) +
            (tu * formatNumber(contract_term)) +
            formatNumber(yearBonus) +
            (formatNumber(performance_bonus)) +
            (formatNumber(medical_check_up)) +
            (formatNumber(hi_and_pa_employee)) +
            (formatNumber(hi_and_pa_dependent));
  
          // Management Fee (14) = (13) x 2%
          const management_fee = (total_labor_cost * 2) / 100;
  
          // TOTAL COST EXCLUDED VAT (15) = (13) + (14)
          const total_cost_excluded_vat = total_labor_cost + management_fee;
  
          // VAT (10%) (16) = (15) x 10%
          const vat = (total_cost_excluded_vat * 10) / 100;
  
          // TOTAL COST INCLUDED VAT (17) = (15) + (16)
          const total_cost_included_vat = parseInt(total_cost_excluded_vat + vat);
  
          form.find("[data-est-cost-input]").val(total_cost_included_vat);
          form
            .find("[data-est-cost-value]")
            .html(numberWithCommas(total_cost_included_vat));
          form.find(".est-result").stop().fadeIn();

          if ($(".est-result").length) {
            $('html, body').animate({
              scrollTop: $(".est-result").offset().top - $('header').height()
            }, 750);
          }
        }

      });
    },
  };

  estLaborCost.init();
});
